import {useQuery} from '@tanstack/react-query';
import {getIsEvaluatedInquiry} from '@/api/help/my-inquiry';

export const isEvaluatedInquiryQueryKey = [
  'help',
  'my-inquiry',
  'detail',
  'is-evaluated-inquiry',
];

export const useGetIsEvaluatedInquiry = ({
  hasAnswer,
  inquiryId,
}: {
  hasAnswer: boolean;
  inquiryId: string;
}) => {
  return useQuery({
    queryKey: [...isEvaluatedInquiryQueryKey, inquiryId],
    enabled: hasAnswer,
    queryFn: () => getIsEvaluatedInquiry({inquiryId}),
    select: ({data}) => Boolean(data.surveyCount),
  });
};
